import { Grid, MenuItem } from '@mui/material';
import { FC, Children, isValidElement, cloneElement, ReactElement, ReactNode } from 'react';
import { FormField } from './FormField';

type FormFieldPropsShape = {
  fieldProps?: Record<string, any>,
  formikProps?: any,
  children?: ReactNode,
};

const isFormFieldElement = (el: ReactElement): el is ReactElement<FormFieldPropsShape> => el.type === FormField;

export const FormContainerMolecule: FC<{ formikProps, formFields?, children?, disabled?: boolean }> = ({ formikProps, formFields, children, disabled }) => {
  const patchedChildren = disabled ? Children.map(children, (child) => {
    if (!isValidElement(child)) return child;
    if (!isFormFieldElement(child)) return child;

    const existingFieldProps = (child.props.fieldProps ?? {}) as Record<string, any>;
    if (typeof existingFieldProps.disabled === 'boolean') return child;

    return cloneElement(child, {
      ...child.props,
      fieldProps: { ...existingFieldProps, disabled: true },
    });
  }) : children;

  return (
    <Grid container direction="row" justifyContent="space-between" alignContent={'stretch'}>
      {formFields?.map((field, i) => (
        <FormField
          key={i}
          fieldProps={{ ...field, disabled: typeof field.disabled === 'boolean' ? field.disabled : disabled }}
          formikProps={formikProps}
        >
          {field.options?.map((option, i) => (
            <MenuItem key={i} value={option.value}>{option.label ?? option.value}</MenuItem>
          ))}
        </FormField>
      ))}
      {patchedChildren}
    </Grid>
  );
};
